import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Footer from '../../components/Footer';
import { API_ENDPOINTS } from '../../config/api';
import { apiFetch } from '../../utils/apiClient';
import './ProcessFlow.css';

const ProcessFlow = () => {
  const { city } = useParams();
  const [processData, setProcessData] = useState({
    pacMixer: { status: 'stop', name: 'PAC搅拌机' },
    pamMixer: { status: 'stop', name: 'PAM搅拌机' },
    pacPump1: { status: 'stop', name: '1#PAC加药泵' },
    pacPump2: { status: 'stop', name: '2#PAC加药泵' },
    pamPump1: { status: 'stop', name: '1#PAM加药泵' },
    pamPump2: { status: 'stop', name: '2#PAM加药泵' },
    emergencyPool: { level: 0, pump1: { status: 'stop', name: '应急池1#提升泵' } },
    regulationPool: { 
      level: 0, 
      pump1: { status: 'stop', name: '调节池1#提升泵' },
      pump2: { status: 'running', name: '调节池2#提升泵' }
    },
    airFlotation: { status: 'stop', name: '气浮装置' },
    sludgePump1: { status: 'stop', name: '1#气浮污泥泵' },
    sludgePump2: { status: 'stop', name: '2#气浮污泥泵' },
    inletFlow: { instant: 0.0, accumulated: 50340.0, name: '进水流量计' },
    outletFlow1: { instant: 0.0, accumulated: 82344.8, name: '出水流量计1' },
    outletFlow2: { instant: 10.6, accumulated: 18070.0, name: '出水流量计2' },
    equalizationPool: {
      level: 4.1,
      hydrogenSulfide: 67.9,
      ammoniaNitrogen: 0.0,
      mixer1: { status: 'stop', name: '1#均质池搅拌机' },
      mixer2: { status: 'stop', name: '2#均质池搅拌机' },
      pump1: { status: 'stop', name: '均质池1#提升泵' },
      pump2: { status: 'stop', name: '均质池2#提升泵' },
      pump3: { status: 'stop', name: '均质池3#提升泵' }
    },
    preAerationPool: {
      ph: 0.0,
      level: 4.4,
      pump1: { status: 'stop', name: '预曝气1#提升泵' },
      pump2: { status: 'stop', name: '预曝气2#提升泵' }
    },
    blowerRoom: { status: 'stop', name: '风机房 预曝气风机' }
  });

  useEffect(() => {
    fetchProcessData();
    const interval = setInterval(fetchProcessData, 5000);
    return () => clearInterval(interval);
  }, [city]);

  const fetchProcessData = async () => {
    try {
      const json = await apiFetch(`${API_ENDPOINTS.PROCESS_FLOW}/${city}`);
      const data = json && json.data ? json.data : json;
      if (data && typeof data === 'object') {
        setProcessData((prev) => ({ ...prev, ...data }));
      }
    } catch (error) {
      console.error('获取工艺流程数据失败:', error);
    }
  };

  const getStatusClass = (status) => {
    return status === 'running' ? 'status-running' : 'status-stopped';
  };

  const getStatusText = (status) => {
    return status === 'running' ? '运行' : '停止';
  };

  return (
    <div className="process-flow-container">
      <div className="process-flow-header">
        <h1>{city}水处理厂工艺流程监控</h1>
        <div className="last-update">
          最后更新: {new Date().toLocaleString('zh-CN')}
        </div>
      </div>

      <div className="process-flow-diagram">
        {/* 左侧 - 化学加药系统 */}
        <div className="left-section">
          <div className="water-source">
            <div className="water-pipe">园区自来水</div>
          </div>
          
          <div className="chemical-dosing">
            <div className="mixer-tanks">
              <div className={`mixer-tank ${getStatusClass(processData.pacMixer.status)}`}>
                <div className="mixer-icon">M</div>
                <div className="mixer-name">{processData.pacMixer.name}</div>
                <div className={`mixer-status ${getStatusClass(processData.pacMixer.status)}`}>
                  {getStatusText(processData.pacMixer.status)}
                </div>
              </div>
              <div className={`mixer-tank ${getStatusClass(processData.pamMixer.status)}`}>
                <div className="mixer-icon">M</div>
                <div className="mixer-name">{processData.pamMixer.name}</div>
                <div className={`mixer-status ${getStatusClass(processData.pamMixer.status)}`}>
                  {getStatusText(processData.pamMixer.status)}
                </div>
              </div>
            </div>
            
            <div className="dosing-pumps">
              <div className={`dosing-pump ${getStatusClass(processData.pacPump1.status)}`}>
                <div className="pump-icon">P</div>
                <div className="pump-name">{processData.pacPump1.name}</div>
                <div className={`pump-status ${getStatusClass(processData.pacPump1.status)}`}>
                  {getStatusText(processData.pacPump1.status)}
                </div>
              </div>
              <div className={`dosing-pump ${getStatusClass(processData.pacPump2.status)}`}>
                <div className="pump-icon">P</div>
                <div className="pump-name">{processData.pacPump2.name}</div>
                <div className={`pump-status ${getStatusClass(processData.pacPump2.status)}`}>
                  {getStatusText(processData.pacPump2.status)}
                </div>
              </div>
              <div className={`dosing-pump ${getStatusClass(processData.pamPump1.status)}`}>
                <div className="pump-icon">P</div>
                <div className="pump-name">{processData.pamPump1.name}</div>
                <div className={`pump-status ${getStatusClass(processData.pamPump1.status)}`}>
                  {getStatusText(processData.pamPump1.status)}
                </div>
              </div>
              <div className={`dosing-pump ${getStatusClass(processData.pamPump2.status)}`}>
                <div className="pump-icon">P</div>
                <div className="pump-name">{processData.pamPump2.name}</div>
                <div className={`pump-status ${getStatusClass(processData.pamPump2.status)}`}>
                  {getStatusText(processData.pamPump2.status)}
                </div>
              </div>
            </div>
          </div>
          
          <div className="collection-tanks">
            <div className="emergency-pool">
              <div className="pool-name">应急池</div>
              <div className="pool-level">液位: {processData.emergencyPool.level} M</div>
              <div className={`pool-pump ${getStatusClass(processData.emergencyPool.pump1.status)}`}>
                <div className="pump-icon">P</div>
                <div className="pump-name">{processData.emergencyPool.pump1.name}</div>
                <div className={`pump-status ${getStatusClass(processData.emergencyPool.pump1.status)}`}>
                  {getStatusText(processData.emergencyPool.pump1.status)}
                </div>
              </div>
            </div>
            
            <div className="regulation-pool">
              <div className="pool-name">调节池</div>
              <div className="pool-level">液位: {processData.regulationPool.level} M</div>
              <div className="pool-pumps">
                <div className={`pool-pump ${getStatusClass(processData.regulationPool.pump1.status)}`}>
                  <div className="pump-icon">P</div>
                  <div className="pump-name">{processData.regulationPool.pump1.name}</div>
                  <div className={`pump-status ${getStatusClass(processData.regulationPool.pump1.status)}`}>
                    {getStatusText(processData.regulationPool.pump1.status)}
                  </div>
                </div>
                <div className={`pool-pump ${getStatusClass(processData.regulationPool.pump2.status)}`}>
                  <div className="pump-icon">P</div>
                  <div className="pump-name">{processData.regulationPool.pump2.name}</div>
                  <div className={`pump-status ${getStatusClass(processData.regulationPool.pump2.status)}`}>
                    {getStatusText(processData.regulationPool.pump2.status)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 中间部分 - 气浮装置和均质池 */}
        <div className="middle-section">
          <div className="air-flotation">
            <div className={`flotation-device ${getStatusClass(processData.airFlotation.status)}`}>
              <div className="device-name">{processData.airFlotation.name}</div>
              <div className={`device-status ${getStatusClass(processData.airFlotation.status)}`}>
                {getStatusText(processData.airFlotation.status)}
              </div>
            </div>
            
            <div className="sludge-pumps">
              <div className={`sludge-pump ${getStatusClass(processData.sludgePump1.status)}`}>
                <div className="pump-icon">P</div>
                <div className="pump-name">{processData.sludgePump1.name}</div>
                <div className={`pump-status ${getStatusClass(processData.sludgePump1.status)}`}>
                  {getStatusText(processData.sludgePump1.status)}
                </div>
              </div>
              <div className={`sludge-pump ${getStatusClass(processData.sludgePump2.status)}`}>
                <div className="pump-icon">P</div>
                <div className="pump-name">{processData.sludgePump2.name}</div>
                <div className={`pump-status ${getStatusClass(processData.sludgePump2.status)}`}>
                  {getStatusText(processData.sludgePump2.status)}
                </div>
              </div>
            </div>
          </div>
          
          <div className="flow-meters">
            <div className="inlet-flow-meter">
              <div className="meter-name">{processData.inletFlow.name}</div>
              <div className="meter-data">
                <div>瞬时流量: {processData.inletFlow.instant} m³/h</div>
                <div>累计流量: {processData.inletFlow.accumulated} m³/h</div>
              </div>
            </div>
          </div>
          
          <div className="equalization-pool">
            <div className="pool-name">均质池</div>
            <div className="pool-parameters">
              <div>液位: {processData.equalizationPool.level} M</div>
              <div>硫化氢: {processData.equalizationPool.hydrogenSulfide} PPM</div>
              <div>氨氮: {processData.equalizationPool.ammoniaNitrogen} PPM</div>
            </div>
            
            <div className="pool-equipment">
              <div className="pool-mixers">
                <div className={`pool-mixer ${getStatusClass(processData.equalizationPool.mixer1.status)}`}>
                  <div className="mixer-icon">M</div>
                  <div className="mixer-name">{processData.equalizationPool.mixer1.name}</div>
                  <div className={`mixer-status ${getStatusClass(processData.equalizationPool.mixer1.status)}`}>
                    {getStatusText(processData.equalizationPool.mixer1.status)}
                  </div>
                </div>
                <div className={`pool-mixer ${getStatusClass(processData.equalizationPool.mixer2.status)}`}>
                  <div className="mixer-icon">M</div>
                  <div className="mixer-name">{processData.equalizationPool.mixer2.name}</div>
                  <div className={`mixer-status ${getStatusClass(processData.equalizationPool.mixer2.status)}`}>
                    {getStatusText(processData.equalizationPool.mixer2.status)}
                  </div>
                </div>
              </div>
              
              <div className="pool-pumps">
                <div className={`pool-pump ${getStatusClass(processData.equalizationPool.pump1.status)}`}>
                  <div className="pump-icon">P</div>
                  <div className="pump-name">{processData.equalizationPool.pump1.name}</div>
                  <div className={`pump-status ${getStatusClass(processData.equalizationPool.pump1.status)}`}>
                    {getStatusText(processData.equalizationPool.pump1.status)}
                  </div>
                </div>
                <div className={`pool-pump ${getStatusClass(processData.equalizationPool.pump2.status)}`}>
                  <div className="pump-icon">P</div>
                  <div className="pump-name">{processData.equalizationPool.pump2.name}</div>
                  <div className={`pump-status ${getStatusClass(processData.equalizationPool.pump2.status)}`}>
                    {getStatusText(processData.equalizationPool.pump2.status)}
                  </div>
                </div>
                <div className={`pool-pump ${getStatusClass(processData.equalizationPool.pump3.status)}`}>
                  <div className="pump-icon">P</div>
                  <div className="pump-name">{processData.equalizationPool.pump3.name}</div>
                  <div className={`pump-status ${getStatusClass(processData.equalizationPool.pump3.status)}`}>
                    {getStatusText(processData.equalizationPool.pump3.status)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 右侧部分 - 生物处理和排放 */}
        <div className="right-section">
          <div className="sludge-storage">
            <div className="storage-tank">
              <div className="tank-name">生化污泥储泥池</div>
            </div>
          </div>
          
          <div className="outlet-flow-meters">
            <div className="outlet-flow-meter">
              <div className="meter-name">{processData.outletFlow1.name}</div>
              <div className="meter-data">
                <div>瞬时流量: {processData.outletFlow1.instant} m³/h</div>
                <div>累计流量: {processData.outletFlow1.accumulated} m³/h</div>
              </div>
              <div className="flow-destination">→ 一级AO反硝化池1</div>
            </div>
            
            <div className="outlet-flow-meter">
              <div className="meter-name">{processData.outletFlow2.name}</div>
              <div className="meter-data">
                <div>瞬时流量: {processData.outletFlow2.instant} m³/h</div>
                <div>累计流量: {processData.outletFlow2.accumulated} m³/h</div>
              </div>
              <div className="flow-destination">→ 一级AO反硝化池2</div>
            </div>
          </div>
          
          <div className="pre-aeration-pool">
            <div className="pool-name">预曝气池</div>
            <div className="pool-parameters">
              <div>PH: {processData.preAerationPool.ph}</div>
              <div>液位: {processData.preAerationPool.level} M</div>
            </div>
            
            <div className="pool-pumps">
              <div className={`pool-pump ${getStatusClass(processData.preAerationPool.pump1.status)}`}>
                <div className="pump-icon">P</div>
                <div className="pump-name">{processData.preAerationPool.pump1.name}</div>
                <div className={`pump-status ${getStatusClass(processData.preAerationPool.pump1.status)}`}>
                  {getStatusText(processData.preAerationPool.pump1.status)}
                </div>
              </div>
              <div className={`pool-pump ${getStatusClass(processData.preAerationPool.pump2.status)}`}>
                <div className="pump-icon">P</div>
                <div className="pump-name">{processData.preAerationPool.pump2.name}</div>
                <div className={`pump-status ${getStatusClass(processData.preAerationPool.pump2.status)}`}>
                  {getStatusText(processData.preAerationPool.pump2.status)}
                </div>
              </div>
            </div>
          </div>
          
          <div className="blower-room">
            <div className={`blower ${getStatusClass(processData.blowerRoom.status)}`}>
              <div className="blower-icon">F</div>
              <div className="blower-name">{processData.blowerRoom.name}</div>
              <div className={`blower-status ${getStatusClass(processData.blowerRoom.status)}`}>
                {getStatusText(processData.blowerRoom.status)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProcessFlow;
